import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["prepaidFields"];

  change(event) {
    this.toggle(event.target.value);
  }

  connect() {
    const select = this.element.querySelector("select[data-action]");
    if (select) {
      this.toggle(select.value);
    }
  }

  toggle(value) {
    if (this.hasPrepaidFieldsTarget) {
      this.prepaidFieldsTarget.classList.toggle("hidden", value !== "prepaid");
    }
  }
}
